import { INSERT_LOCATION_SUCCESS_HANDLER } from "../actions/types";

export default (state = {}, action) => {
  switch (action.type) {
    case INSERT_LOCATION_SUCCESS_HANDLER:
      return action.payload;
    default:
      return state;
  }
};
